import { render, staticRenderFns } from "./PromotionDetails.vue?vue&type=template&id=76f65837&"
import script from "./PromotionDetails.vue?vue&type=script&lang=ts&"
export * from "./PromotionDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports